import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameMusicalChairs: Palette['primary']
	}

	interface PaletteOptions {
		gameMusicalChairs?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameMusicalChairs: true
	}
}

export const gameMusicalChairsColor = {
	main: '#2CAABB',
	light: '#E2F5F8',
} as PaletteColor
